import Sidebar from '../Sidebar';
import './index.scss';

const Layout = ()=>{
    return(
        <Sidebar/>
    );
}

export default Layout;